import type { Dispatch, SetStateAction } from "react";
import SearchFilter from "~components/SearchFilter/SearchFilter";
import SelectNationality from "~components/SelectNationality";
import SelectPersonGender from "~components/SelectPersonGender";
import SelectPersonStatus from "~components/SelectPersonStatus";
import type { RoleStatuses } from "~enums/roleStatuses";
import type { LabelValue } from "~types/labelValue.ts";

type Props = {
  searchValue: string;
  setSearchValue: Dispatch<SetStateAction<string>>;
  setNationality: Dispatch<SetStateAction<string | undefined>>;
  setGender: Dispatch<SetStateAction<string | undefined>>;
  setStatus: Dispatch<SetStateAction<RoleStatuses | undefined>>;
  disabled?: boolean;
  resetPagination: () => void;
};

export const AddPersonRolesModalFilters = ({
  setGender,
  setNationality,
  searchValue,
  setSearchValue,
  setStatus,
  disabled = false,
  resetPagination,
}: Props) => (
  <>
    <SelectNationality
      onChange={(value) => {
        resetPagination();
        setNationality(value as string | undefined);
      }}
      disabled={disabled}
    />
    <SelectPersonGender
      onChange={(gender) => {
        resetPagination();
        setGender((gender as LabelValue).value);
      }}
      disabled={disabled}
    />
    <SelectPersonStatus
      onChange={(status) => {
        resetPagination();
        setStatus((status as LabelValue).value as RoleStatuses | undefined);
      }}
      disabled={disabled}
    />
    <SearchFilter
      initial={searchValue}
      searchValue={searchValue}
      doSearch={(value) => {
        resetPagination();
        setSearchValue(value);
      }}
      placeholderIntlKey="search.two.letters"
    />
  </>
);
